import React from 'react'
import productPlaceholder from '@loyal_images/products/product_placeholder.png'

const ProductSuggestionPlaceholder = () => (

  <div className='container-card container pt-3 pb-1 py-md-3 px-0 px-md-1'>
    <div className='row mx-0'>
      <div className='col mr-auto mb-2 mx--1 mx-md-0 px-2 px-md-0'>
        <div className='row'>
          <div className='col-12 col-md-6 mb-1 py-half txt-body-sm color-ui-2 bg-ui-3 txt-font-body txt-center w-100 radius' />
        </div>
      </div>
      <div className='col-1 d-none d-md-flex'>
        <div className='row'>
          <div className='col-12 mb-1 py-half txt-body-sm color-ui-2 bg-ui-3 txt-font-body txt-center w-100 radius' />
        </div>
      </div>
    </div>
    <div className='bx-showcase-products pos-relative'>
      <div className='row row-eq-height w-100'>
        <div className='item card col-6 col-sm-4 col-md-3 px-1'>
          <div className='bordered radius border-color-ui-4 bg-white'>
            <div className='row mx-0 px-2'>
              <div className='col-12 txt-center pt-2'>
                <div className='row align-items-center h-100'>
                  <div className='col-8 ml-auto mr-auto'>
                    <img src={productPlaceholder} alt={productPlaceholder} className='mw-100' />
                  </div>
                </div>
              </div>

              <div className='card-name col-12 mt-1'>
                <div className='row'>
                  <div className='col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                  <div className='col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                </div>
              </div>
              <div className='card-price col-12  mt-2 mb-1 color-brand-1'>
                <div className='row align-items-center h-100'>
                  <div className='card-price-points col-12 txt-headline txt-circular-black txt-center'>
                    <div className='row'>
                      <div className='col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                    </div>
                  </div>
                  <div className='card-price-currency col-12 txt-body txt-circular-black txt-center'>
                    <div className='row'>
                      <div className='col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='item card  col-6 col-sm-4 col-md-3 px-1'>
          <div className='bordered radius border-color-ui-4 bg-white'>
            <div className='row mx-0 px-2'>
              <div className='col-12 txt-center pt-2'>
                <div className='row align-items-center h-100'>
                  <div className='col-8 ml-auto mr-auto'>
                    <img src={productPlaceholder} alt={productPlaceholder} className='mw-100' />
                  </div>
                </div>
              </div>

              <div className='card-name col-12 mt-1'>
                <div className='row'>
                  <div className='col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                  <div className='col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                </div>
              </div>
              <div className='card-price col-12  mt-2 mb-1 color-brand-1'>
                <div className='row align-items-center h-100'>
                  <div className='card-price-points col-12 txt-headline txt-circular-black txt-center'>
                    <div className='row'>
                      <div className='col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                    </div>
                  </div>
                  <div className='card-price-currency col-12 txt-body txt-circular-black txt-center'>
                    <div className='row'>
                      <div className='col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='item card  col-6 col-sm-4 col-md-3 px-1 d-none  d-md-flex '>
          <div className='bordered radius border-color-ui-4 bg-white'>
            <div className='row mx-0 px-2'>
              <div className='col-12 txt-center pt-2'>
                <div className='row align-items-center h-100'>
                  <div className='col-8 ml-auto mr-auto'>
                    <img src={productPlaceholder} alt={productPlaceholder} className='mw-100' />
                  </div>
                </div>
              </div>

              <div className='card-name col-12 mt-1'>
                <div className='row'>
                  <div className='col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                  <div className='col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                </div>
              </div>
              <div className='card-price col-12  mt-2 mb-1 color-brand-1'>
                <div className='row align-items-center h-100'>
                  <div className='card-price-points col-12 txt-headline txt-circular-black txt-center'>
                    <div className='row'>
                      <div className='col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                    </div>
                  </div>
                  <div className='card-price-currency col-12 txt-body txt-circular-black txt-center'>
                    <div className='row'>
                      <div className='col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='item card  col-6 col-sm-4 col-md-3 d-none d-md-flex px-1'>
          <div className='bordered radius border-color-ui-4 bg-white'>
            <div className='row mx-0 px-2'>
              <div className='col-12 txt-center pt-2'>
                <div className='row align-items-center h-100'>
                  <div className='col-8 ml-auto mr-auto'>
                    <img src={productPlaceholder} alt={productPlaceholder} className='mw-100' />
                  </div>
                </div>
              </div>

              <div className='card-name col-12 mt-1'>
                <div className='row'>
                  <div className='col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                  <div className='col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                </div>
              </div>
              <div className='card-price col-12  mt-2 mb-1 color-brand-1'>
                <div className='row align-items-center h-100'>
                  <div className='card-price-points col-12 txt-headline txt-circular-black txt-center'>
                    <div className='row'>
                      <div className='col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                    </div>
                  </div>
                  <div className='card-price-currency col-12 txt-body txt-circular-black txt-center'>
                    <div className='row'>
                      <div className='col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

)

export default ProductSuggestionPlaceholder



// WEBPACK FOOTER //
// ./src/features/Suggestion/ProductSuggestion/ProductSuggestionPlaceholder.js